(function () {
  function initFade(slider) {
    var track = slider.querySelector('.collection-other-products__grid--slider');
    if (!track) return;

    function update() {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      var atStart = track.scrollLeft <= 2;
      var fits = track.scrollWidth <= track.clientWidth + 2;
      slider.classList.toggle('collection-other-products__slider--at-end', atEnd);
      slider.classList.toggle('collection-other-products__slider--scrolled', !atStart);
      track.classList.toggle('collection-other-products__grid--fits', fits);
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('.collection-other-products__slider').forEach(initFade);
})();
